import { RefObject, useLayoutEffect, useState } from 'react';

const getTrailingCaption = (root: HTMLElement): Element | null => {
  let node = root.lastElementChild;
  let firstCaption: Element | null = null;

  while (node?.classList.contains('caption')) {
    firstCaption = node;
    node = node.previousElementSibling;
  }

  return firstCaption;
};

/**
 * Возвращает DOM-узел внутри статьи, в который можно порталить форму:
 * перед хвостовыми `.caption`, а если их нет — в конец контента.
 */
export const usePlaceBeforeTrailingCaption = (
  contentRef: RefObject<HTMLElement | null>,
  enabled: boolean,
  content: string,
): HTMLElement | null | undefined => {
  const [mountNode, setMountNode] = useState<HTMLElement | null | undefined>(undefined);

  useLayoutEffect(() => {
    if (!enabled || !contentRef.current) {
      setMountNode(null);

      return;
    }

    const node = document.createElement('div');
    const caption = getTrailingCaption(contentRef.current);

    if (caption) {
      contentRef.current.insertBefore(node, caption);
    } else {
      contentRef.current.appendChild(node);
    }

    setMountNode(node);

    return () => node.remove();
  }, [content, contentRef, enabled]);

  return mountNode;
};
